// Fighter Data
const fightersData = [
  { name: "Mario", wins: "1", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/mario/main.png" },
  { name: "Donkey Kong", wins: "1", tier: "A", series: "Donkey Kong", img: "https://www.smashbros.com/assets_v2/img/fighter/donkey_kong/main.png" },
  { name: "Link", wins: "1", tier: "A", series: "Legend of Zelda", img: "https://www.smashbros.com/assets_v2/img/fighter/link/main.png" },
  { name: "Samus", wins: "1", tier: "A", series: "Metroid", img: "https://www.smashbros.com/assets_v2/img/fighter/samus/main.png" },
  { name: "Dark Samus", wins: "0", tier: "A", series: "Metroid", img: "https://www.smashbros.com/assets_v2/img/fighter/dark_samus/main.png" },
  { name: "Yoshi", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/yoshi/main.png" },
  { name: "Kirby", wins: "0", tier: "A", series: "Kirby", img: "https://www.smashbros.com/assets_v2/img/fighter/kirby/main.png" },
  { name: "Fox", wins: "1", tier: "A", series: "Star Fox", img: "https://www.smashbros.com/assets_v2/img/fighter/fox/main.png" },
  { name: "Pikachu", wins: "2", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/pikachu/main.png" },
  { name: "Luigi", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/luigi/main.png" },
  { name: "Ness", wins: "1", tier: "A", series: "Earth Bound", img: "https://www.smashbros.com/assets_v2/img/fighter/ness/main.png" },
  { name: "Captain Falcon", wins: "4", tier: "A", series: "F-Zero", img: "https://www.smashbros.com/assets_v2/img/fighter/captain_falcon/main.png" },
  { name: "Jigglypuff", wins: "1", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/jigglypuff/main.png" },
  { name: "Peach", wins: "1", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/peach/main.png" },
  { name: "Daisy", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/daisy/main.png" },
  { name: "Bowser", wins: "3", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/bowser/main.png" },
  { name: "Ice Climbers", wins: "2", tier: "A", series: "Ice Climber", img: "https://www.smashbros.com/assets_v2/img/fighter/ice_climbers/main.png" },
  { name: "Sheik", wins: "2", tier: "A", series: "Legend of Zelda", img: "https://www.smashbros.com/assets_v2/img/fighter/sheik/main.png" },
  { name: "Zelda", wins: "0", tier: "A", series: "Legend of Zelda", img: "https://www.smashbros.com/assets_v2/img/fighter/zelda/main.png" },
  { name: "Dr. Mario", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/dr_mario/main.png" },
  { name: "Pichu", wins: "0", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/pichu/main.png" },
  { name: "Falco", wins: "0", tier: "A", series: "Star Fox", img: "https://www.smashbros.com/assets_v2/img/fighter/falco/main.png" },
  { name: "Marth", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/marth/main.png" },
  { name: "Lucina", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/lucina/main.png" },
  { name: "Young Link", wins: "0", tier: "A", series: "Legend of Zelda", img: "https://www.smashbros.com/assets_v2/img/fighter/young_link/main.png" },
  { name: "Ganondorf", wins: "0", tier: "A", series: "Legend of Zelda", img: "https://www.smashbros.com/assets_v2/img/fighter/ganondorf/main.png" },
  { name: "Mewtwo", wins: "0", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/mewtwo/main.png" },
  { name: "Roy", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/roy/main.png" },
  { name: "Chrom", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/chrom/main.png" },
  { name: "Mr. Game and Watch", wins: "0", tier: "A", series: "Game & Watch", img: "https://www.smashbros.com/assets_v2/img/fighter/mr_game_and_watch/main.png" },
  { name: "Meta Knight", wins: "0", tier: "A", series: "Kirby", img: "https://www.smashbros.com/assets_v2/img/fighter/meta_knight/main.png" },
  { name: "Pit", wins: "0", tier: "A", series: "Kid Icarus", img: "https://www.smashbros.com/assets_v2/img/fighter/pit/main.png" },
  { name: "Dark Pit", wins: "0", tier: "A", series: "Kid Icarus", img: "https://www.smashbros.com/assets_v2/img/fighter/dark_pit/main.png" },
  { name: "Zero Suit Samus", wins: "0", tier: "A", series: "Metroid", img: "https://www.smashbros.com/assets_v2/img/fighter/zero_suit_samus/main.png" },
  { name: "Wario", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/wario/main.png" },
  { name: "Snake", wins: "0", tier: "A", series: "Metal Gear", img: "https://www.smashbros.com/assets_v2/img/fighter/snake/main.png" },
  { name: "Ike", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/ike/main.png" },
  { name: "Pokemon Trainer", wins: "0", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/pokemon_trainer/main.png" },
  { name: "Diddy Kong", wins: "0", tier: "A", series: "Donkey Kong", img: "https://www.smashbros.com/assets_v2/img/fighter/diddy_kong/main.png" },
  { name: "Lucas", wins: "0", tier: "A", series: "Earth Bound", img: "https://www.smashbros.com/assets_v2/img/fighter/lucas/main.png" },
  { name: "Sonic", wins: "0", tier: "A", series: "Sonic", img: "https://www.smashbros.com/assets_v2/img/fighter/sonic/main.png" },
  { name: "King Dedede", wins: "0", tier: "A", series: "Kirby", img: "https://www.smashbros.com/assets_v2/img/fighter/king_dedede/main.png" },
  { name: "Olimar", wins: "0", tier: "A", series: "Pikmin", img: "https://www.smashbros.com/assets_v2/img/fighter/olimar/main.png" },
  { name: "Lucario", wins: "0", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/lucario/main.png" },
  { name: "ROB", wins: "0", tier: "A", series: "ROB", img: "https://www.smashbros.com/assets_v2/img/fighter/rob/main.png" },
  { name: "Toon Link", wins: "0", tier: "A", series: "Legend of Zelda", img: "https://www.smashbros.com/assets_v2/img/fighter/toon_link/main.png" },
  { name: "Wolf", wins: "0", tier: "A", series: "Star Fox", img: "https://www.smashbros.com/assets_v2/img/fighter/wolf/main.png" },
  { name: "Villager", wins: "0", tier: "A", series: "Animal Crossing", img: "https://www.smashbros.com/assets_v2/img/fighter/villager/main.png" },
  { name: "Mega Man", wins: "0", tier: "A", series: "Mega Man", img: "https://www.smashbros.com/assets_v2/img/fighter/mega_man/main.png" },
  { name: "Wii Fit Trainer", wins: "0", tier: "A", series: "Wii Fit", img: "https://www.smashbros.com/assets_v2/img/fighter/wii_fit_trainer/main.png" },
  { name: "Rosalina and Luma", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/rosalina_and_luma/main.png" },
  { name: "Little Mac", wins: "0", tier: "A", series: "Punch-Out", img: "https://www.smashbros.com/assets_v2/img/fighter/little_mac/main.png" },
  { name: "Greninja", wins: "0", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/greninja/main.png" },
  { name: "Palutena", wins: "0", tier: "A", series: "Kid Icarus", img: "https://www.smashbros.com/assets_v2/img/fighter/palutena/main.png" },
  { name: "Pac-Man", wins: "0", tier: "A", series: "Pac-Man", img: "https://www.smashbros.com/assets_v2/img/fighter/pac_man/main.png" },
  { name: "Robin", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/robin/main.png" },
  { name: "Shulk", wins: "0", tier: "A", series: "Xenoblade", img: "https://www.smashbros.com/assets_v2/img/fighter/shulk/main.png" },
  { name: "Bowser Jr.", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/bowser_jr/main.png" },
  { name: "Duck Hunt", wins: "0", tier: "A", series: "Duck Hunt", img: "https://www.smashbros.com/assets_v2/img/fighter/duck_hunt/main.png" },
  { name: "Ryu", wins: "0", tier: "A", series: "Street Fighter", img: "https://www.smashbros.com/assets_v2/img/fighter/ryu/main.png" },
  { name: "Ken", wins: "0", tier: "A", series: "Street Fighter", img: "https://www.smashbros.com/assets_v2/img/fighter/ken/main.png" },
  { name: "Corrin", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/corrin/main.png" },
  { name: "Bayonetta", wins: "0", tier: "A", series: "Bayonetta", img: "https://www.smashbros.com/assets_v2/img/fighter/bayonetta/main.png" },
  { name: "Inkling", wins: "0", tier: "A", series: "Splatoon", img: "https://www.smashbros.com/assets_v2/img/fighter/inkling/main.png" },
  { name: "Ridley", wins: "0", tier: "A", series: "Metroid", img: "https://www.smashbros.com/assets_v2/img/fighter/ridley/main.png" },
  { name: "Simon", wins: "0", tier: "A", series: "Castlevania", img: "https://www.smashbros.com/assets_v2/img/fighter/simon/main.png" },
  { name: "Richter", wins: "0", tier: "A", series: "Castlevania", img: "https://www.smashbros.com/assets_v2/img/fighter/richter/main.png" },
  { name: "King K. Rool", wins: "0", tier: "A", series: "Donkey Kong", img: "https://www.smashbros.com/assets_v2/img/fighter/king_k_rool/main.png" },
  { name: "Isabelle", wins: "0", tier: "A", series: "Animal Crossing", img: "https://www.smashbros.com/assets_v2/img/fighter/isabelle/main.png" },
  { name: "Incineroar", wins: "0", tier: "A", series: "Pokemon", img: "https://www.smashbros.com/assets_v2/img/fighter/incineroar/main.png" },
  { name: "Piranha Plant", wins: "0", tier: "A", series: "Super Mario", img: "https://www.smashbros.com/assets_v2/img/fighter/piranha_plant/main.png" },
  { name: "Joker", wins: "0", tier: "A", series: "Persona5", img: "https://www.smashbros.com/assets_v2/img/fighter/joker/main.png" },
  { name: "Hero", wins: "0", tier: "A", series: "Dragon Quest", img: "https://www.smashbros.com/assets_v2/img/fighter/dq_hero/main.png" },
  { name: "Banjo & Kazooie", wins: "0", tier: "A", series: "Banjo & Kazooie", img: "https://www.smashbros.com/assets_v2/img/fighter/banjo_and_kazooie/main.png" },
  { name: "Terry", wins: "0", tier: "A", series: "Fatal Fury", img: "https://www.smashbros.com/assets_v2/img/fighter/terry/main.png" },
  { name: "Byleth", wins: "0", tier: "A", series: "Fire Emblem", img: "https://www.smashbros.com/assets_v2/img/fighter/byleth/main.png" },
  { name: "Pyra", wins: "0", tier: "A", series: "Xenoblade", img: "https://www.smashbros.com/assets_v2/img/fighter/pyra/main.png" },
  { name: "Mythra", wins: "0", tier: "A", series: "Xenoblade", img: "https://www.smashbros.com/assets_v2/img/fighter/pyra/main.png" },
  { name: "Mii Brawler", wins: "0", tier: "A", series: "Mii", img: "https://www.smashbros.com/assets_v2/img/fighter/mii_fighter/main_en.png" },
  { name: "Mii Gunner", wins: "0", tier: "A", series: "Mii", img: "https://www.smashbros.com/assets_v2/img/fighter/mii_fighter/main_en.png" },
  { name: "Mii Swordfighter", wins: "0", tier: "A", series: "Mii", img: "https://www.smashbros.com/assets_v2/img/fighter/mii_fighter/main_en.png" },
  { name: "Cloud", wins: "0", tier: "A", series: "FF7", img: "https://www.smashbros.com/assets_v2/img/fighter/cloud/main.png" }
];


// Maps
const maps = [
    "Battlefield",
    "Big Battlefield",
    "Final Destination",
    "Peach's Castle",
    "Kongo Jungle",
    "Hyrule Castle",
    "Super Happy Tree",
    "Saffron City",
    "Mushroom Kingdom",
    "Princess Peach's Castle",
    "Rainbow Cruise",
    "Kongo Falls",
    "Jungle Japes",
    "Great Bay",
    "Temple",
    "Brinstar",
    "Onett",
    "Fourside",
    "Corneria",
    "Venom",
    "Pokémon Stadium",
    "Big Blue",
    "Fountain of Dreams",
    "Green Greens",
    "Yoshi's Story",
    "Yoshi's Island (Melee)",
    "Mushroom Kingdom II",
    "Brinstar Depths",
    "Delfino Plaza",
    "Mushroomy Kingdom",
    "Figure-8 Circuit",
    "WarioWare, Inc.",
    "Bridge of Eldin",
    "Norfair",
    "Frigate Orpheon",
    "Yoshi's Island",
    "Halberd",
    "Lylat Cruise",
    "Pokémon Stadium 2",
    "Port Town Aero Dive",
    "Castle Siege",
    "Distant Planet",
    "Smashville",
    "New Pork City",
    "Summit",
    "Skyworld",
    "Shadow Moses Island",
    "Luigi's Mansion",
    "Pirate Ship",
    "Spear Pillar",
    "75m",
    "Mario Bros.",
    "Hanenbow",
    "Green Hill Zone",
    "3D Land",
    "Golden Plains",
    "Paper Mario",
    "Gerudo Valley",
    "Spirit Train",
    "Dream Land GB",
    "Unova Pokémon League",
    "Prism Tower",
    "Mute City SNES",
    "Arena Ferox",
    "Reset Bomb Forest",
    "Tortimer Island",
    "Find Mii",
    "Tomodachi Life",
    "PictoChat 2",
    "Living Room",
    "Balloon Fight",
    "Magicant",
    "Mushroom Kingdom U",
    "Mario Galaxy",
    "Mario Circuit",
    "Skyloft",
    "The Great Cave Offensive",
    "Gamer",
    "Garden of Hope",
    "Town and City",
    "Wii Fit Studio",
    "Wrecking Crew",
    "Pilotwings",
    "Wuhu Island",
    "Coliseum",
    "Boxing Ring",
    "Gaur Plain",
    "Duck Hunt",
    "Wily Castle",
    "Suzaku Castle",
    "Midgar",
    "Umbra Clock Tower",
    "New Donk City Hall",
    "Great Plateau Tower",
    "Moray Towers",
    "Dracula's Castle"
];



const videoviews = [
  "430",
  "223",
  "162",
  "164",
  "209",
  "151"
];

const videourls = [
  "https://youtu.be/A1hxkeoeBTY",
  "https://youtu.be/JaBL9lWThnk",
  "https://youtu.be/gDmufZaYjBE",
  "https://youtu.be/ZUlVdcyOU_w",
  "https://youtu.be/aUlcnEX_l3k",
  "https://youtu.be/dX2o9kUQvao"
];

const battlesData = [
  { fighter1: fightersData[8].name, fighter1img: fightersData[8].img, fighter2: fightersData[14].name, fighter2img: fightersData[14].img, title: `${fightersData[8].name} VS. ${fightersData[14].name}`, map: maps[24], views: videoviews[0], url: videourls[0]},
  { fighter1: fightersData[7].name, fighter1img: fightersData[7].img, fighter2: fightersData[8].name, fighter2img: fightersData[8].img, title: `${fightersData[7].name} VS. ${fightersData[8].name}`, map: maps[25], views: videoviews[1], url: videourls[1]},
  { fighter1: fightersData[44].name, fighter1img: fightersData[44].img, fighter2: fightersData[53].name, fighter2img: fightersData[53].img, title: `${fightersData[44].name} VS. ${fightersData[53].name}`, map: maps[80], views: videoviews[2], url: videourls[2]},
  { fighter1: fightersData[54].name, fighter1img: fightersData[54].img, fighter2: fightersData[55].name, fighter2img: fightersData[55].img, title: `${fightersData[54].name} VS. ${fightersData[55].name}`, map: maps[53], views: videoviews[3], url: videourls[3]},
  { fighter1: fightersData[67].name, fighter1img: fightersData[67].img, fighter2: fightersData[43].name, fighter2img: fightersData[43].img, title: `${fightersData[67].name} VS. ${fightersData[43].name}`, map: maps[30], views: videoviews[4], url: videourls[4]},
  { fighter1: fightersData[13].name, fighter1img: fightersData[13].img, fighter2: fightersData[21].name, fighter2img: fightersData[21].img, title: `${fightersData[13].name} VS. ${fightersData[21].name}`, map: maps[55], views: videoviews[5], url: videourls[5]}
];

// State
let searchQuery = "";
let sortBy = "wins";
let sortOrder = "desc";
let selectedTier = "all";

// Create particles
function createParticles() {
  const container = document.getElementById('particles');
  for (let i = 0; i < 50; i++) {
    const particle = document.createElement('div');
    particle.className = 'particle';
    const size = Math.random() * 4 + 1;
    particle.style.cssText = `
      left: ${Math.random() * 100}%;
      top: ${Math.random() * 100}%;
      width: ${size}px;
      height: ${size}px;
      animation-duration: ${Math.random() * 20 + 10}s;
      animation-delay: ${Math.random() * 5}s;
    `;
    container.appendChild(particle);
  }
}

// Get tier color class
function getTierColorClass(tier) {
  const colors = {
    S: 'initial-S',
    A: 'initial-A',
    B: 'initial-B',
    C: 'initial-C',
    D: 'initial-D'
  };
  return colors[tier] || 'initial-C';
}

function getBarClass(tier) {
  return `bar-${tier}`;
}

// Render fighter card
function renderFighterCard(fighter, rank) {
  const maxWins = 1247;
  const barWidth = (fighter.wins / maxWins) * 100;
  const medalClass = fighter.wins >= 1000 ? 'gold' : fighter.wins >= 500 ? 'silver' : '';
  
  let rankHtml = '';
  if (rank <= 3) {
    rankHtml = `<div class="fighter-rank rank-${rank}">${rank}</div>`;
  }
  
  return `
    <div class="fighter-card" style="--tier-color: var(--${fighter.tier === 'S' ? 'yellow-400' : fighter.tier === 'A' ? 'yellow-500' : fighter.tier === 'B' ? 'amber-500' : 'neutral-500'})">
      ${rankHtml}
      <div class="fighter-tier tier-${fighter.tier}">${fighter.tier}-Tier</div>
      <div class="fighter-avatar" style="background-image: url('${fighter.img ?? "https://via.placeholder.com/150"}');background-size: cover;">
        <div class="fighter-initial ${getTierColorClass(fighter.tier)}">${fighter.name[0]}</div>
      </div>
      <div class="fighter-info">
        <div class="fighter-name">${fighter.name}</div>
        <div class="fighter-series">Series: ${fighter.series}</div>
        <div class="fighter-stats">
          <div class="fighter-wins">

            <span class="wins-count">${fighter.wins}</span>
            <span class="wins-label">wins</span>
          </div>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="fighter-medal ${medalClass}">
            <path d="M7 21h10"></path>
            <path d="M12 21V11"></path>
            <path d="m12 11-4-4 4-4 4 4-4 4z"></path>
            <path d="m8 7-4 4 4 4"></path>
            <path d="m16 7 4 4-4 4"></path>
          </svg>
        </div>
        <div class="fighter-bar">
          <div class="fighter-bar-fill ${getBarClass(fighter.tier)}" style="width: ${barWidth}%"></div>
        </div>
      </div>
    </div>
  `;
}

// Render battle card
function renderBattleCard(battle) {
  return `
    <div class="battle-card">
      <div class="battle-visual" style="
  background-image: url('${battle.fighter1img}'), url('${battle.fighter2img}');
  /* Prevent images from repeating */
  background-repeat: no-repeat, no-repeat;
  /* Adjust image sizes as needed */
  background-size: contain, contain;
  /* Position image 1 on left, image 2 on right */
  /* Format: x-axis y-axis */
  background-position: calc(70% - 100px) 10px, calc(40% + 100px) 10px;" >
        <div class="battle-fighters">
          <div class="battle-fighter fighter-1">${battle.fighter1[0]}</div>
          <div class="battle-vs">VS.</div>
          <div class="battle-fighter fighter-2">${battle.fighter2[0]}</div>
        </div>
        <div class="battle-views">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path>
          </svg>
          ${battle.views}
        </div>
      </div>
      <div class="battle-content">
        <h3 class="battle-title">${battle.title}</h3>
        <div class="battle-meta">
          <span class="battle-tournament">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 6L9 3L15 6L21 3V18L15 21L9 18L3 21V6Z"></path>
              <line x1="9" y1="3" x2="9" y2="18"></line>
              <line x1="15" y1="6" x2="15" y2="21"></line>
            </svg> ${battle.map}</span>
          <a href="${battle.url}" target="_blank">
            <button class="battle-play">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
            </button>
          </a>
        </div>
      </div>
    </div>
  `;
}

// Filter and sort fighters
function getFilteredFighters() {
  let result = [...fightersData];
  
  // Filter by search
  if (searchQuery) {
    result = result.filter(f => f.name.toLowerCase().includes(searchQuery.toLowerCase()));
  }
  
  // Filter by tier
  if (selectedTier !== "all") {
    result = result.filter(f => f.tier === selectedTier);
  }
  
  // Sort
  result.sort((a, b) => {
    if (sortBy === "wins") {
      return sortOrder === "desc" ? b.wins - a.wins : a.wins - b.wins;
    }
    if (sortBy === "name") {
      return sortOrder === "desc" ? b.name.localeCompare(a.name) : a.name.localeCompare(b.name);
    }
    return 0;
  });
  
  return result;
}

// Render fighters
function renderFighters() {
  const grid = document.getElementById('fighterGrid');
  const noResults = document.getElementById('noResults');
  const resultsCount = document.getElementById('resultsCount');
  
  const fighters = getFilteredFighters();
  resultsCount.textContent = fighters.length;
  
  if (fighters.length === 0) {
    grid.innerHTML = '';
    noResults.classList.remove('hidden');
    return;
  }
  
  noResults.classList.add('hidden');
  grid.innerHTML = fighters.map((fighter, index) => renderFighterCard(fighter, index + 1)).join('');
}

// Render battles
function renderBattles() {
  const grid = document.getElementById('battleGrid');
  grid.innerHTML = battlesData.map(battle => renderBattleCard(battle)).join('');
}

// Event listeners
function setupEventListeners() {
  // Search
  document.getElementById('searchInput').addEventListener('input', (e) => {
    searchQuery = e.target.value;
    renderFighters();
  });
  
  // Tier buttons
  document.querySelectorAll('.tier-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.tier-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      selectedTier = btn.dataset.tier;
      renderFighters();
    });
  });
  
  // Sort select
  document.getElementById('sortSelect').addEventListener('change', (e) => {
    sortBy = e.target.value;
    renderFighters();
  });
  
  // Sort order
  document.getElementById('sortOrderBtn').addEventListener('click', () => {
    sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
    renderFighters();
  });
}

// Initialize
function init() {
  createParticles();
  renderFighters();
  renderBattles();
  setupEventListeners();
}

// Run on DOM ready
document.addEventListener('DOMContentLoaded', init);